import React, { useState } from "react";
import { CampaignViewDetailsProps } from "./campaign-view-details.props";
import LeadViewDetailsView from "./campaign-view-details-view/campaign-view-details-view";
import LeadViewDetailsEdit from "./campaign-view-details-edit/campaign-view-details-edit";
import "./campaign-view-details.scss";

const CampaignViewDetails: React.FC<CampaignViewDetailsProps> = (
  props: any
) => {
  const {
    campaignDetails,
    selectedCampaignId,
    setLoading,
    viewEditOpen,
    viewFullInfoOpen,
    setViewFullInfoOpen,
    uploadedImage,
    setUploadedImage,
    uploadedImageFile,
    setUploadedImageFile,
    setRemoveImage,
    removeImage,
    fetchCampaignDetails,
    onCampaignNameUpdate,
    resetImageUpload,
    permissions,
  } = props;
  return (
    <div className="lead-list-view-details-edit-view">
      <div className="lead-list-view-details-view">
        <LeadViewDetailsView
          campaignDetails={campaignDetails}
          setLoading={setLoading}
          selectedCampaignId={selectedCampaignId}
          viewEditOpen={viewEditOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          setViewFullInfoOpen={setViewFullInfoOpen}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
          uploadedImageFile={uploadedImageFile}
          setUploadedImageFile={setUploadedImageFile}
          setRemoveImage={setRemoveImage}
          removeImage={removeImage}
          fetchCampaignDetails={fetchCampaignDetails}
          onCampaignNameUpdate={onCampaignNameUpdate}
          resetImageUpload={resetImageUpload}
          permissions={permissions}
        />
      </div>
    </div>
  );
};

export default CampaignViewDetails;
